import { IoMdMore } from "react-icons/io";
import { FaAngleDown, FaRegCalendarDays } from "react-icons/fa6";
import { GoDotFill } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
 import { IoReceipt } from "react-icons/io5";
import ContracctDetails from "./ContracctDetails";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import usePositionHook from "../../../hooks/usePositionHook";
import { Fragment, useEffect, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { CiEdit } from "react-icons/ci";
import { FiFileMinus } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { onUpdateContract } from "../../../services/contract";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { toast } from "react-toastify";
import Contracts from "./Contracts";

export default ({ item }: any) => {
  const navigate = useNavigate();

  const { selectedOrgEmployees } = useEmployeeHook();
  const { selectedOrgDepts } = useDepartmentHook();
  const { allorgPositions } = usePositionHook();
  const [positionname, setpositionname] = useState("");
  const [emplname, setemplname] = useState("");
  const [deptname, setdeptname] = useState("");
  const { setLoading } = useStateSetter();
  const { setSidebarRenderView, setselectedEmpl } = useStateSetter();
  const startdate = new Date(item.startDate);
  const enddate = new Date(item.endDate);
  const { config } = useStateGetter();

  useEffect(() => {
    allorgPositions.map((it: any) => {
      if (it.id == item.positionID) {
        setpositionname(it.positionTitle);
      }
    });

    selectedOrgDepts.map((it: any) => {
      if (it.id == item.deptID) {
        setdeptname(it.deptName);
      }
    });
    selectedOrgEmployees.map((it: any) => {
      if (it.id == item.employeeID) {
        setemplname(`${it.firstName} ${it.lastName}`);
      }
    });
  }, [allorgPositions, selectedOrgDepts]);

  const CloseConract = async () => {
    setLoading(true);
    var res = await onUpdateContract(
      { status: "completed", id: item.id },
      config
    );
    toast("Contract Closed");
    setSidebarRenderView(<Contracts />);
    setLoading(false);
  };
  return (
    <div className="bg-whit shadow-sm border border-gray-200 rounded-[10px] flex  py-4  px-1 justify-between items-center">
      <div
        onClick={() => {
          setselectedEmpl(item);
          console.log(item);
          setSidebarRenderView(<ContracctDetails id={item.id} />);
        }}
        className="flex"
      >
        <div className=" px-2">
          <p className="font-semibold cursor-pointer">
            {item.firstName} {item.title}{" "}
            <p className="font-light text-xs cursor-pointer inline">
              <GoDotFill className="inline text-green-600" /> {item.status}
            </p>
          </p>
          <p className="font-light text-xs cursor-pointer flex gap-2 ">
            <FaRegCalendarDays className="text-textbg inline  " />
            {enddate.getFullYear()}/{enddate.getMonth()}/{enddate.getDay()} -{" "}
            {startdate.getFullYear()}/{startdate.getMonth()}/
            {startdate.getDay()}
            <IoReceipt className="text-textbg inline  " />
            <p className="inline">{item.type}</p>
          </p>
          <p className="text-gray-400 text-sm my-2 "> {emplname}</p>
          <div className="flex  gap-2">
            <p className="inline text-xs bg-faintBlue p-1 rounded">
              {positionname}
            </p>{" "}
            <p className="inline text-xs bg-faintBlue p-1 rounded">
              {deptname}
            </p>
          </div>
        </div>
      </div>
      <Menu as="div" className={`relative my-2 `}>
        <Menu.Button className="   w-full       ">
          <div className="flex flex-items items-center  w-full gap-4">
            <div className=" flex justify-between w-full  items-center p-1">
              <IoMdMore size={20} className="text-textbg " />
            </div>

            <div className="flex items-center"></div>
          </div>
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            onClick={() => {
              setselectedEmpl(item);
              console.log(item);
              setSidebarRenderView(<ContracctDetails id={item.id} />);
            }}
            className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[150px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <Menu.Item>
              <p
                onClick={() => {}}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <CiEdit className="inline" /> Edit
              </p>
            </Menu.Item>
            <Menu.Item>
              <p
                onClick={async () => {
                  CloseConract();
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <FiFileMinus className="inline" /> Close Contract
              </p>
            </Menu.Item>
            <Menu.Item>
              <p
                onClick={() => {}}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <MdDelete className="inline" /> Delete
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
